(function() {
    var ua = navigator.userAgent.toLowerCase();
    if (SAPO.Utility.FullScreen.isSupported && /android.+samsung.+chrome/g.test(ua)) {
        SAPO.Utility.FullScreen.isSupported = false;
    }
})();
